export default __webpack_public_path__ + "static/media/prodslide4.2cf168f1.jpg";